export default __webpack_public_path__ + "static/media/3.5673c896.png";